import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import "./ListContent.css";
import { Editor } from "primereact/editor";

function ListContents() {
  let emptyListContent = {
    id: null,
    title: "",
    description: "",
    sortOrder: null,
  };
  const [ListContents, setListContents] = useState(null);

  const [ListContentsDialog, setListContentsDialog] = useState(false);
  const [DeleteListContent, setDeleteListContent] = useState(false);
  const [DeleteListContentsDialog, setDeleteListContentsDialog] =
    useState(false);
  const [ListContent, setListContent] = useState(emptyListContent);
  const [selectedListContents, setSelectedListContents] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getListContents();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getListContents = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/HomePageListContents"
      );

      if (response.data) {
        setListContents(response.data);
      }
    } catch (error) {
      console.error("Error fetching List Contents:", error);
    }
  };

  const openNew = () => {
    setListContent(emptyListContent);
    setSubmitted(false);
    setListContentsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setListContentsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteListContent(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteListContentsDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      let _ListContents = [...ListContents];
      let _ListContent = { ...ListContent };

      if (ListContent.id) {
        const index = findIndexById(ListContent.id);

        const payload = {
          Id: _ListContent.id,
          Title: _ListContent.title,
          Description: _ListContent.description,
          SortOrder: isNaN(parseInt(_ListContent.sortOrder))
            ? 1
            : parseInt(_ListContent.sortOrder),
        };

        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL +
            "api/HomePageListContents/" +
            ListContent.id,
          payload,
          {
            headers: {
              "Content-Type": "application/json", // ✅ Proper for JSON body
            },
          }
        );

        if (response.data) {
          _ListContents[index] = _ListContent;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "List Content Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "List Content Not Updated",
            life: 3000,
          });
        }
      } else {
        _ListContent.id = createId();
        const payload = {
          Title: _ListContent.title,
          Description: _ListContent.description,
          SortOrder: isNaN(parseInt(_ListContent.sortOrder))
            ? 1
            : parseInt(_ListContent.sortOrder),
        };

        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/HomePageListContents",
          payload,
          {
            headers: {
              "Content-Type": "application/json", // ✅ Proper for JSON body
            },
          }
        );

        if (response.data) {
          _ListContents.push(response.data);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "List Content Added",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "List Content Not Added",
            life: 3000,
          });
        }
      }

      setListContents(_ListContents);
      setListContentsDialog(false);
      setListContent(emptyListContent);
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the list content. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (ListContent) => {
    setListContent({ ...ListContent });
    setListContentsDialog(true);
  };

  const confirmDeleteProduct = (ListContent) => {
    setListContent(ListContent);
    setDeleteListContent(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL +
          "api/HomePageListContents/" +
          ListContent.id
      );

      setLoading(false);

      if (response.data.success) {
        let _ListContents = ListContents.filter(
          (val) => val.id !== ListContent.id
        );
        setListContents(_ListContents);
        setDeleteListContent(false);
        setListContent(emptyListContent);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "List Content Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "List Content Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < ListContents.length; i++) {
      if (ListContents[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteListContentsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedListContents.map((ListContent) => ListContent.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL +
        "api/HomePageListContents/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _ListContents = ListContents.filter(
        (val) => !selectedListContents.includes(val)
      );
      setListContents(_ListContents);
      setDeleteListContentsDialog(false);
      setSelectedListContents(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "List Contents Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "List Contents Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _ListContent = { ...ListContent };

    _ListContent[`${name}`] = val;

    setListContent(_ListContent);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Home List Content</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedListContents || !selectedListContents.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Product Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  function truncateHtml(html, maxLength) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    const truncatedText =
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    return truncatedText;
  }

  return (
    <div className="col-12">
      <div className="ListContent-container">
        <Toast ref={toast} />
        <div className="card">
          <Toolbar
            className="mb-3"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>

          <DataTable
            ref={dt}
            value={ListContents}
            selection={selectedListContents}
            onSelectionChange={(e) => setSelectedListContents(e.value)}
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Product Icons"
            globalFilter={globalFilter}
            header={header}
          >
            <Column selectionMode="multiple" exportable={false}></Column>
            <Column
              field="id"
              header="Code"
              sortable
              width="150px"
              style={{ textAlign: "center" }}
            ></Column>

            <Column
              field="title"
              header="Title"
              sortable
              style={{ minWidth: "12rem" }}
            ></Column>
            <Column
              field="description"
              header="Description"
              sortable
              style={{ minWidth: "12rem" }}
              body={(rowData) => (
                <div
                  dangerouslySetInnerHTML={{
                    __html: truncateHtml(rowData.description, 50),
                  }}
                />
              )}
            ></Column>

            <Column
              field="sortOrder"
              header="Order"
              sortable
              style={{ textAlign: "center" }}
            ></Column>

            <Column
              body={actionBodyTemplate}
              exportable={false}
              style={{ minWidth: "12rem" }}
            ></Column>
          </DataTable>
        </div>

        <Dialog
          visible={ListContentsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="ListContent Details"
          modal
          className="p-fluid"
          footer={productDialogFooter}
          onHide={hideDialog}
        >
          <div className="field">
            <label htmlFor="title" className="font-bold mb-1">
              Title :
            </label>
            <InputText
              id="title"
              value={ListContent.title ?? ""}
              onChange={(e) => onInputChange(e, "title")}
              required
              className={classNames({
                "p-invalid": submitted && !ListContent.title,
              })}
            />
            {submitted && !ListContent.title && (
              <small className="p-error">Title is required.</small>
            )}
          </div>
          <div className="field">
            <label htmlFor="description" className="font-bold mb-1">
              Description :
            </label>
            <Editor
              id="description"
              value={ListContent.description ?? ""}
              style={{ height: "100px" }}
              onTextChange={(e) =>
                onInputChange({ target: { value: e.htmlValue } }, "description")
              }
              required
              className={classNames({
                "p-invalid": submitted && !ListContent.description,
              })}
            />
          </div>

          <div className="field">
            <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
              Order :
            </label>
            <InputText
              id="sortOrder"
              type="number"
              value={ListContent.sortOrder ?? 1}
              onChange={(e) => onInputChange(e, "sortOrder")}
              required
              className={classNames({
                "p-invalid": submitted && !ListContent.sortOrder,
              })}
            />
            {submitted && !ListContent.sortOrder && (
              <small className="p-error">Sort Order is required.</small>
            )}
          </div>
        </Dialog>

        <Dialog
          visible={DeleteListContent}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductDialogFooter}
          onHide={hideDeleteProductDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            <div>
              <p style={{ textAlign: "center", marginBottom: "5px" }}>
                Are you sure you want to delete:
              </p>
              {ListContent && (
                <p style={{ textAlign: "center", marginBottom: "0" }}>
                  <b>{ListContent.title}</b>
                </p>
              )}
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={DeleteListContentsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductsDialogFooter}
          onHide={hideDeleteProductsDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            {ListContent && (
              <p
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "25px",
                }}
              >
                Are you sure you want to delete the selected List Contents?
              </p>
            )}
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default ListContents;
